/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { SeverityLevel } from "@microsoft/applicationinsights-web";
import applicationInsightsTelemetryClient from "../AppInsights/appInsightsTelemetryClient";
import { environment } from "../environment";

export default class ConsoleLogger {
    // https://stackoverflow.com/questions/9277780/can-i-extend-the-console-object-for-rerouting-the-logging-in-javascript?noredirect=1&lq=1
    public static overrideLogging() {
        const override = () => {
            const consoleLog = console.log;
            console.log = function() {
                ConsoleLogger.trackAndLog(consoleLog, arguments, SeverityLevel.Information);
            };

            const consoleDebug = console.debug;
            console.debug = function() {
                ConsoleLogger.trackAndLog(consoleDebug, arguments, SeverityLevel.Verbose);
            };


            const consoleInfo = console.info;
            console.info = function() {
                ConsoleLogger.trackAndLog(consoleInfo, arguments, SeverityLevel.Information);
            };

            const consoleWarn = console.warn;
            console.warn = function() {
                ConsoleLogger.trackAndLog(consoleWarn, arguments, SeverityLevel.Warning);
            };

            const consoleError = console.error;
            console.error = function() {
                ConsoleLogger.trackAndLog(consoleError, arguments, SeverityLevel.Error);
            };

            const consoleTrace = console.trace;
            console.trace = function() {
                ConsoleLogger.trackAndLog(consoleTrace, arguments, SeverityLevel.Verbose);
            };
        };

        if (!environment.isReactDevelopmentBuild) {
            override();
        }
    }

    private static trackAndLog(logFunc: (...data: any[]) => void, args: IArguments, level: SeverityLevel) {
        const argumentsArray = Array.from(args);
        ConsoleLogger.track(argumentsArray, level);
        logFunc.apply(console, argumentsArray);
    }

    private static track(data: any[], severityLevel: SeverityLevel) {
        applicationInsightsTelemetryClient.trackTrace({
            message: JSON.stringify(data),
            severityLevel
        });
    }
}